export default __webpack_public_path__ + "static/media/survey-white.087281f2.svg";